import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function SocialProof() {
  return <section className="py-20 lg:py-28 bg-white" data-id="element-430">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10" data-id="element-431">
        {/* Section Header */}
        <div className="reveal text-center max-w-2xl mx-auto" data-id="element-432">
          <h2 className="font-serif text-3xl md:text-4xl text-tlfc-text" data-id="element-433">
            What our clients say
          </h2>
        </div>

        {/* Testimonials Grid */}
        <div className="reveal-stagger mt-12 grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-434">
          {/* Testimonial 1 */}
          <div className="bg-tlfc-stone/50 border border-tlfc-border rounded-xl p-8" data-id="element-435">
            <QuoteIcon className="w-8 h-8 text-tlfc-gold/30" aria-hidden="true" data-id="element-436" />
            <div className="flex gap-1 mt-4" data-id="element-437">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-tlfc-gold text-tlfc-gold" aria-hidden="true" data-id="element-438" />)}
            </div>
            <p className="mt-4 text-tlfc-text leading-relaxed" data-id="element-439">
              "TLFC guided us through a complex property acquisition with
              clarity and precision. Their expertise made what could have been
              overwhelming feel straightforward."
            </p>
            <p className="mt-6 text-sm text-tlfc-muted font-medium" data-id="element-440">
              — Property Development Client
            </p>
          </div>

          {/* Testimonial 2 */}
          <div className="bg-tlfc-stone/50 border border-tlfc-border rounded-xl p-8" data-id="element-441">
            <QuoteIcon className="w-8 h-8 text-tlfc-gold/30" aria-hidden="true" data-id="element-442" />
            <div className="flex gap-1 mt-4" data-id="element-443">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-tlfc-gold text-tlfc-gold" aria-hidden="true" data-id="element-444" />)}
            </div>
            <p className="mt-4 text-tlfc-text leading-relaxed" data-id="element-445">
              "During the most difficult time of my life, the family law team
              provided compassionate, strategic support. I felt heard and
              protected throughout."
            </p>
            <p className="mt-6 text-sm text-tlfc-muted font-medium" data-id="element-446">
              — Family Law Client
            </p>
          </div>

          {/* Testimonial 3 */}
          <div className="bg-tlfc-stone/50 border border-tlfc-border rounded-xl p-8" data-id="element-447">
            <QuoteIcon className="w-8 h-8 text-tlfc-gold/30" aria-hidden="true" data-id="element-448" />
            <div className="flex gap-1 mt-4" data-id="element-449">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-tlfc-gold text-tlfc-gold" aria-hidden="true" data-id="element-450" />)}
            </div>
            <p className="mt-4 text-tlfc-text leading-relaxed" data-id="element-451">
              "Their commercial litigation team resolved our dispute efficiently
              and achieved an outcome that exceeded our expectations."
            </p>
            <p className="mt-6 text-sm text-tlfc-muted font-medium" data-id="element-452">
              — Business Client
            </p>
          </div>
        </div>
      </div>
    </section>;
}